import { render, staticRenderFns } from "./StoryDetail.vue?vue&type=template&id=c9474950&"
import script from "./StoryDetail.vue?vue&type=script&lang=js&"
export * from "./StoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports